/**
 * Replace all occurrences of a variable in a text.
 * @param {string} text
 */
import { store } from '../../../../resources/frontend/js/store/index';

export default text => {
    const element = document.createElement('div');

    element.innerHTML = text;

    const variables = element.querySelectorAll('[data-quill-type="variable"]');

    variables.forEach(variable => {
        let type = variable.getAttribute('data-value');
        const name = type.split(':')[0];
        let text = store.state.page.variables[name];

        if (!text) {
            variable.innerText = '';
            return;
        }

        text = text.toString();
        if (type.split(':')[1] === 'uppercase') text = text.toUpperCase();

        variable.innerText = text;
    });

    return element.innerHTML;
};
